// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import api from '../../../../../../../services/api';


const getBookshopTotalService = async (data) => {
  return api(
    `/Sellitback.svc/GetBookshopTotal?CustomerId=${data.CustomerId}&Token=${data.Token}`,
    {},
    'GET'
  );
};

const getRecentVouchersService = async (data) => {
  return api(
    '/Sellitback.svc/RecentVouchers',
    data,
    'POST'
  );
};

const searchVouchersService = async (data) => {
  return api(
    '/Sellitback.svc/SearchVouchers',
    data,
    'POST'
  );
};

export {
  getBookshopTotalService,
  getRecentVouchersService,
  searchVouchersService,
};
